import React from 'react';
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';
import { Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/main.scss';

const PrivacyPage = () => (
  <>
    <Helmet>
      <html lang="ja" />
      <title>プライバシーポリシー・運営者情報 | KenRp01</title>
      <meta
        name="description"
        content="KenRp01ポートフォリオの運営者情報、個人情報の取り扱い、アクセス解析、広告配信、Cookieに関する方針です。"
      />
    </Helmet>
    <main className="py-5">
      <Container style={{ maxWidth: '840px' }}>
        <h1 className="mb-5">プライバシーポリシー・運営者情報</h1>

        <section className="mb-5">
          <h2>運営者情報</h2>
          <p>
            当サイトは、バックエンドエンジニアのKenRp01が運営するポートフォリオです。個人開発の成果と、技術検証から得た知識を公開しています。
          </p>
        </section>

        <section className="mb-5">
          <h2>個人情報の取り扱い</h2>
          <p>
            お問い合わせ時に提供されたメールアドレスなどの情報は、回答に必要な範囲でのみ利用し、法令に基づく場合を除いて第三者へ提供しません。
          </p>
        </section>

        <section className="mb-5">
          <h2>アクセス解析とCookie</h2>
          <p>
            当サイトでは、利用状況を把握して内容を改善するためにGoogle
            Analyticsを利用しています。Google
            AnalyticsはCookieを使用して匿名の利用情報を収集します。Cookieはブラウザの設定から無効にできます。
          </p>
        </section>

        <section className="mb-5">
          <h2>広告について</h2>
          <p>
            当サイトでGoogle
            AdSenseなどの広告配信サービスを利用する場合、Googleを含む第三者配信事業者がCookieを使用して広告を配信することがあります。
            これにより、利用者が当サイトや他のサイトへ過去にアクセスした情報に基づいて、パーソナライズ広告が表示される場合があります。
          </p>
          <p>
            パーソナライズ広告は、Googleの広告設定から無効にできます。また、第三者配信事業者のCookieをブラウザ設定から無効にすることもできます。
            当サイトでは、広告と本文・ナビゲーションを区別できる配置を守り、広告クリックを促す表示は行いません。
          </p>
        </section>

        <section className="mb-5">
          <h2>免責事項</h2>
          <p>
            掲載内容は可能な範囲で正確性を確認していますが、その完全性を保証するものではありません。当サイトの情報を利用したことで生じた損害について、運営者は責任を負いかねます。
          </p>
        </section>

        <section className="mb-5">
          <h2>お問い合わせ</h2>
          <p>
            本方針に関するお問い合わせは
            <a href="mailto:kinema@digdig.org">kinema@digdig.org</a>
            までお願いします。
          </p>
        </section>

        <p>制定日: 2026年7月7日</p>
        <Link to="/">トップページへ戻る</Link>
      </Container>
    </main>
  </>
);

export default PrivacyPage;
